import { Box, Typography } from '@wishket/design-system';

interface SearchSectionTitleProps {
  title: string;
  count: number;
}

const SearchSectionTitle = ({ title, count }: SearchSectionTitleProps) => {
  return (
    <Box className="flex gap-2 grid-in-content">
      <Typography variant="subTitle1" className="font-medium text-w-gray-900">
        {title}
      </Typography>
      <Typography variant="subTitle1" className="font-medium text-primary">
        {count}
      </Typography>
    </Box>
  );
};

export default SearchSectionTitle;
